import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './leaveStyle.css';
import config from '../../config.json';
import LeaveLabel from './LeaveLabel';

const apiUrl = config.apiUrl;

const LeaveDelete = () => {
    const [leaveDetails, setLeaveDetails] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        LeaveType: '',
        Duration: '',
        Remarks: '',
        Status: '',
    });

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const navigate = useNavigate();
    const { leaveId } = useParams();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchLeaveData = async () => {
            setIsDisable(true);
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/Leave/${leaveId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch leave data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setLeaveDetails({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    LeaveType: data.Details.LeaveType,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });
                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching leave data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchLeaveData();
    }, []);

    const handleDelete = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Leave/Delete/${leaveId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setErrorMessage('');
                setSuccessMessage(data.Message);
                setIsDisable(false);
                navigate('/leave-list');
            }
        } catch (error) {
            setErrorMessage('Error deleting leave');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        LeaveType,
        Duration,
        Remarks,
        Status,
    } = leaveDetails;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasStandard) ? (
                <>
                    <h3>Delete Leave</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleDelete}>
                        <div className="row mt-4">
                            <LeaveLabel label="Transaction ID" value={TransactionID} />
                            <LeaveLabel label="Transaction Date" value={TransactionDate} />
                            <LeaveLabel label="Employee" value={Employee.Name} />
                            <LeaveLabel label="Leave Type" value={LeaveType} />
                            <LeaveLabel label="Date Start" value={DateStart} />
                            <LeaveLabel label="Date End" value={DateEnd} />
                            <LeaveLabel label="Duration" value={Duration} />
                            <LeaveLabel label="Remarks" value={Remarks} />
                            <LeaveLabel label="Status" value={Status} />
                        </div>

                        <div className="mb-2">
                            <Link to="/leave-list" className="btn btn-secondary me-2">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    disabled={isDisable}
                                >
                                    Delete
                                </button>
                            )}
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default LeaveDelete;
